import React from 'react';
import { Provider } from 'react-redux';

import store from './store';
import Routes from './routes';
import './App.css';
import './App.custom.less';
import './aws-configure.ts';

function App() {
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
}

export default App;
